import React, { FunctionComponent, PropsWithChildren, ReactElement } from 'react'

import './Widget.scss'

export interface OwnProps {
  propClassName?: string
}

type Props = PropsWithChildren<OwnProps>

const Widget: FunctionComponent<Props> = ({ children, propClassName = '' }: Props): ReactElement => (
  <div className={`Widget ${propClassName}`}>
    <div className="Widget-content">
      {children}
    </div>
  </div>
)

export default Widget
